import { useEffect, useState } from "react";
import { getBillingRates, type BillingRate } from "@/lib/api";

// 利用ガイドの料金ページはこれで単価を取るので、単価の改定はレートカードの更新だけで反映される。

/**
 * 現在適用中の単価を取得する。active が true になるたびに取り直す
 * (改定が反映されないまま古い値を見せないため)。
 */
export function useBillingRates(active: boolean): {
	rates: BillingRate[] | null;
	error: string | null;
} {
	const [rates, setRates] = useState<BillingRate[] | null>(null);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		if (!active) return;
		let cancelled = false;
		setError(null);
		setRates(null);
		getBillingRates()
			.then((data) => {
				if (!cancelled) setRates(data);
			})
			.catch((err: Error) => {
				if (cancelled) return;
				console.error("単価の取得に失敗しました", err);
				setError(err.message);
			});
		return () => {
			cancelled = true;
		};
	}, [active]);

	return { rates, error };
}
